import * as React from 'react';
import { MobileLogin } from '../../Scenes/ExpoMobile/MobileLogin';

export interface IMobileAppLoginProps {
}

export default function MobileAppLogin(props: IMobileAppLoginProps) {
    return (
        <MobileLogin />
    );
}
